var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgItunes = function SvgItunes(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 .883a7.118 7.118 0 0 1 0 14.234A7.112 7.112 0 0 1 4.89 12c0-3.93 3.18-7.117 7.11-7.117Zm3.334 1.78-5.548 1.5H9.78v2.257h.006v4.035a1.672 1.672 0 0 0-.86-.233c-.823 0-1.487.572-1.487 1.274 0 .702.664 1.268 1.487 1.268.823 0 1.523-.566 1.494-1.268l-.015-.36-.037-4.877 4.384-1.184v4.455a1.654 1.654 0 0 0-.938-.284c-.823 0-1.487.572-1.487 1.274 0 .702.664 1.267 1.487 1.267.824 0 1.516-.565 1.516-1.267v-.02l.004-5.58V6.664Z",
    fill: "currentColor"
  })));
};
export default SvgItunes;